import React, { useEffect, useRef, useState } from "react";
import { useForeContext } from "../../../../../models";
import { userActions } from "../../../../../actions/user";
import { Postback } from "../../RichMessageTypes";
import { WidgetButton } from "@fidget/common/components/widgetButton/widgetButton";
import styles from "./DynamicSuggestions.css";
import {
  Direction,
  NavigationButton,
  NavigationButtonStyleType
} from "../navigationButton/NavigationButton";

interface Props {
  dynamicSugestions: string[];
  isMobile?: boolean;
}

export const DynamicSuggestions = ({ dynamicSugestions, isMobile }: Props) => {
  // tslint:disable-next-line:no-null-keyword
  const containerRef = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  const scrollLeft = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({ left: -200, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({ left: 200, behavior: "smooth" });
    }
  };

  const updateNavigationButton = (event?: Event) => {
    const t = (event ? event.target : containerRef.current) as HTMLElement;

    setCanScrollLeft(t.scrollLeft > 0);
    setCanScrollRight(Math.ceil(t.scrollLeft + t.clientWidth) < Math.floor(t.scrollWidth));
  };

  useEffect(() => {
    const ref = containerRef.current;
    if (ref) {
      ref.addEventListener("scroll", updateNavigationButton);
      updateNavigationButton();
      return () => {
        ref.removeEventListener("scroll", updateNavigationButton);
      };
    }
    return;
  }, []);

  const context = useForeContext();
  const handleSendMessage = (text: string, postback?: Postback) => {
    userActions.sendMessageWithPostback(context, text, postback);
  };

  return (
    <div className={styles["suggestions-wrapper"]}>
      {!isMobile && (
        <NavigationButton
          direction={Direction.PREVIOUS}
          navigationButtonStyle={NavigationButtonStyleType.DYNAMIC_SUGGESTIONS}
          onClick={scrollLeft}
          hidden={!canScrollLeft}
        />
      )}
      <div className={styles["suggestions-container"]} ref={containerRef}>
        {dynamicSugestions.map((dynamicSugestion) => (
          <WidgetButton
            key={dynamicSugestion}
            onClick={() => handleSendMessage(dynamicSugestion)}
            buttonStyle="dynamicSuggestion"
            disabled={false}
          >
            {dynamicSugestion}
          </WidgetButton>
        ))}
      </div>
      {!isMobile && (
        <NavigationButton
          direction={Direction.NEXT}
          navigationButtonStyle={NavigationButtonStyleType.DYNAMIC_SUGGESTIONS}
          onClick={scrollRight}
          hidden={!canScrollRight}
        />
      )}
    </div>
  );
};
